import {useMemo} from 'react'
import {useQuery} from 'react-query'

import {getProcessMetricsMetaData} from '../common/backend'
import {QueryKeyName} from '../common/constants'
import {ProcessMetaData} from '../declarations'

import {usePlantId} from './usePlantId'

export const useProcessMetaData = (): ProcessMetaData[] => {
  const plantId = usePlantId()
  const {data} = useQuery([QueryKeyName.GetProcessMetaData, plantId], async () => {
    const metaData = await getProcessMetricsMetaData(plantId)
    return {metaData}
  })
  return useMemo(() => data?.metaData ?? [], [data])
}
